var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isFcl,
              expression: "isFcl"
            }
          ],
          staticStyle: {
            flex: "1",
            display: "flex",
            "flex-direction": "column"
          }
        },
        [
          _c(
            "div",
            { staticClass: "section" },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "7px", "padding-bottom": "7px" }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled: !_vm.$checkPermission([
                          "button_TabFclContractNoPrice_add"
                        ])
                      },
                      on: { click: _vm.addContractNo }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AddContractNo")))]
                  )
                ],
                1
              ),
              _c("cargo-ag-grid", {
                attrs: {
                  "grid-params": _vm.fcl.up.girdParams,
                  "grid-options": _vm.fcl.up.gridOptions,
                  "column-defs": _vm.fcl.up.columnDefs,
                  "row-data": _vm.fcl.up.rowData,
                  "show-side-bar": false
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(_vm.fcl.up, "girdParams", $event)
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(_vm.fcl.up, "girdParams", $event)
                  },
                  gridReady: function(params) {
                    _vm.fcl.up.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section", staticStyle: { flex: "1" } },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "7px", "padding-bottom": "7px" }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled: !_vm.$checkPermission([
                          "button_TabFclContractNoPrice_save"
                        ])
                      },
                      on: { click: _vm.addContractPrice }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                  )
                ],
                1
              ),
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%" },
                attrs: {
                  "grid-params": _vm.fcl.down.girdParams,
                  "grid-options": _vm.fcl.down.gridOptions,
                  "column-defs": _vm.fcl.down.columnDefs,
                  "row-data": _vm.fcl.down.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(_vm.fcl.down, "girdParams", $event)
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(_vm.fcl.down, "girdParams", $event)
                  },
                  gridReady: function(params) {
                    _vm.fcl.down.gridApi = params.api
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isFcl,
              expression: "!isFcl"
            }
          ],
          staticStyle: {
            flex: "1",
            display: "flex",
            "flex-direction": "column"
          }
        },
        [
          _c(
            "div",
            { staticClass: "section" },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "7px", "padding-bottom": "7px" }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: !_vm.$checkPermission([
                          "button_TabLclContractNoPrice_add"
                        ]),
                        type: "primary"
                      },
                      on: { click: _vm.addContractNo }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AddContractNo")))]
                  )
                ],
                1
              ),
              _c("cargo-ag-grid", {
                attrs: {
                  "config-module": "101406",
                  "grid-params": _vm.lcl.up.girdParams,
                  "grid-options": _vm.lcl.up.gridOptions,
                  "column-defs": _vm.lcl.up.columnDefs,
                  "row-data": _vm.lcl.up.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(_vm.lcl.up, "girdParams", $event)
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(_vm.lcl.up, "girdParams", $event)
                  },
                  gridReady: function(params) {
                    _vm.lcl.up.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section", staticStyle: { flex: "1" } },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "7px", "padding-bottom": "7px" }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled: !_vm.$checkPermission([
                          "button_TabFclContractNoPrice_save"
                        ])
                      },
                      on: { click: _vm.addContractPrice }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                  )
                ],
                1
              ),
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%" },
                attrs: {
                  "grid-params": _vm.lcl.down.girdParams,
                  "grid-options": _vm.lcl.down.gridOptions,
                  "column-defs": _vm.lcl.down.columnDefs,
                  "row-data": _vm.lcl.down.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    return _vm.$set(_vm.lcl.down, "girdParams", $event)
                  },
                  "update:grid-params": function($event) {
                    return _vm.$set(_vm.lcl.down, "girdParams", $event)
                  },
                  gridReady: function(params) {
                    _vm.lcl.down.gridApi = params.api
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _vm.dialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.dialog.visible,
                title: _vm.$t("CargoMsg.Cargo_AddContractNo"),
                width: "800px",
                "close-on-click-modal": false,
                "append-to-body": ""
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.dialog, "visible", $event)
                },
                close: _vm.closeDialog
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: { "padding-bottom": "10px" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "100px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "SeaExport.ShippingCompanyContractNo"
                                    ),
                                    required: ""
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      disabled: !_vm.dialog.isEdit,
                                      filterable: "",
                                      "default-value":
                                        _vm.dialog.scno || undefined,
                                      cache: false,
                                      "tag-name": "scno",
                                      "tag-value": "scno",
                                      "filter-tag-names": ["scno"],
                                      "static-options": _vm.dialog.scnoList
                                    },
                                    on: { parentCallBack: _vm.onScNoChange }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("SeaExport.InnerContractNo"),
                                    required: ""
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: !_vm.dialog.isEdit },
                                    model: {
                                      value: _vm.dialog.contractNo,
                                      callback: function($$v) {
                                        _vm.$set(_vm.dialog, "contractNo", $$v)
                                      },
                                      expression: "dialog.contractNo"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_EffectiveDate"
                                    ),
                                    required: ""
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: !_vm.dialog.isEdit,
                                      editable: false,
                                      type: "date",
                                      "value-format": "yyyy-MM-dd"
                                    },
                                    model: {
                                      value: _vm.dialog.beginDate,
                                      callback: function($$v) {
                                        _vm.$set(_vm.dialog, "beginDate", $$v)
                                      },
                                      expression: "dialog.beginDate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_InvalidDate"),
                                    required: ""
                                  }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: !_vm.dialog.isEdit,
                                      editable: false,
                                      type: "date",
                                      "value-format": "yyyy-MM-dd"
                                    },
                                    model: {
                                      value: _vm.dialog.endDate,
                                      callback: function($$v) {
                                        _vm.$set(_vm.dialog, "endDate", $$v)
                                      },
                                      expression: "dialog.endDate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-top": "10px",
                        "margin-bottom": "10px",
                        "font-size": "14px",
                        "font-weight": "bold"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Partners.defaultMarkupRange")))]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-top": "10px",
                        "margin-bottom": "10px"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: _vm.loadType
                              ? !_vm.$checkPermission([
                                  "button_TabFclContractNoPrice_priceAdd"
                                ])
                              : !_vm.$checkPermission([
                                  "button_TabLclContractNoPrice_priceAdd"
                                ])
                          },
                          on: { click: _vm.addDefaultPrice }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "danger",
                            disabled: _vm.loadType
                              ? !_vm.$checkPermission([
                                  "button_TabFclContractNoPrice_priceDelete"
                                ])
                              : !_vm.$checkPermission([
                                  "button_TabLclContractNoPrice_priceDelete"
                                ])
                          },
                          on: { click: _vm.deleteDefaultPrice }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "section", staticStyle: { flex: "1" } },
                    [
                      _c("cargo-ag-grid", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "grid-params": _vm.dialog.girdParams,
                          "grid-options": _vm.dialog.gridOptions,
                          "column-defs": _vm.dialogColumnDefs,
                          "row-data": _vm.dialog.rowData,
                          "show-side-bar": false
                        },
                        on: {
                          "update:gridParams": function($event) {
                            return _vm.$set(_vm.dialog, "girdParams", $event)
                          },
                          "update:grid-params": function($event) {
                            return _vm.$set(_vm.dialog, "girdParams", $event)
                          },
                          gridReady: function(params) {
                            _vm.dialog.gridApi = params.api
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.checkSaveContractNo }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                  ),
                  _c("el-button", { on: { click: _vm.closeDialog } }, [
                    _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
                  ])
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }